// eslint-disable-next-line
interface MessageData extends Record<string, any> {
  text: string
}

export const messageData = (str: string): MessageData => {
  if (!str?.startsWith('{')) {
    return { text: str }
  }
  // Try to parse it as JSON
  try {
    const parsed = JSON.parse(str)
    // In the past, Quick Replies were sent with "question: ..." not "text: ...". If this is an old Quick Reply question, fix it!
    if (parsed.question) {
      parsed.text = parsed.question
    }
    // Finally, return the parsed object
    return parsed
  } catch (e) {
    return { text: str }
  }
}
